import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { BOOKING_URL, isBookingConfigured } from '../data/proposal';
type BookingLinkProps = {
  label: string;
  size?: 'md' | 'sm';
};

/** Navy meeting-booking button. Opens the configured booking URL in a new tab. */
export function BookingLink({
  label,
  size = 'md'
}: BookingLinkProps) {
  const sizing = size === 'md' ? 'px-6 py-3.5 text-[15px] gap-2.5' : 'px-4 py-2 text-[13px] gap-1.5';
  return <a href={isBookingConfigured ? BOOKING_URL : '#booking-link-not-configured'} target={isBookingConfigured ? '_blank' : undefined} rel={isBookingConfigured ? 'noopener noreferrer' : undefined} onClick={e => {
    if (!isBookingConfigured) e.preventDefault();
  }} title={isBookingConfigured ? undefined : 'Booking link not yet configured — set BOOKING_URL in data/proposal.ts'} className={`group inline-flex items-center whitespace-nowrap rounded-full bg-navy font-medium text-white shadow-[0_10px_24px_-12px_rgba(30,58,95,0.7)] transition-[background-color,transform] duration-150 ease-out hover:bg-ink active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy ${sizing}`} data-id="element-20" data-mp="cirjk120vbsp">
      {label}
      <ArrowRightIcon size={size === 'md' ? 16 : 14} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-21" data-mp="264kou1krsz4f" />
    </a>;
}